import Scene from "./Scene";
import common from "../common";
import {translate} from "../utils";

export default class ResultsScene extends Scene {
    constructor() {
        super();
    }

    init() {
        super.init();

        this._bg = new PIXI.Sprite(P3.assets.texture("results_bg"));
        this._bg.width = common.STAGE_WIDTH;
        this._bg.height = common.STAGE_HEIGHT;
        this.addChild(this._bg);

        this._dustCloud = new PIXI.Sprite(P3.assets.texture("asset_cloud"));
        this._dustCloud.anchor.set(0.5);
        this._dustCloud.position.set(common.STAGE_WIDTH * 0.5 - 100, common.STAGE_HEIGHT * 0.5);
        this.addChild(this._dustCloud);

        this._label = new PIXI.Text(translate("results"), {
            fontFamily: "bangersregular",
            fontSize: 160,
            align: "center",
            fill: 0xff6100,
            stroke: 0xffffff,
            strokeThickness: 5,
            padding: 24,
            dropShadow: true,
            dropShadowAngle: 7.7,
            dropShadowColor: 0x949494,
            wordWrap:true,
            wordWrapWidth:400
        });
        this._label.anchor.set(0.5);
        this._label.rotation = -Math.PI * 0.05;
        this._label.position.set(40, -40);
        this._dustCloud.addChild(this._label);

        /*
        this._panel = new PIXI.Sprite(P3.assets.texture("panel_end_screen"));
        this._panel.anchor.set(0.5);
        this._panel.position.set(common.STAGE_WIDTH * 0.5 + 200, common.STAGE_HEIGHT * 0.5 + 200);
        this.addChild(this._panel);
         */

        this._tom = new PIXI.spine.Spine(P3.assets.spineData("tom_side"));
        this._tom.state.setAnimation(0, "dizzy", true);
        this._tom.scale.set(0.6);
        this._tom.scale.x = -this._tom.scale.x;
        this._tom.position.set(common.STAGE_WIDTH * 0.5 + 340, common.STAGE_HEIGHT);
        this._tom.autoUpdate = false;
        this.addChild(this._tom);

        this._stars = new PIXI.spine.Spine(P3.assets.spineData("vfx_stars"));
        this._stars.state.setAnimation(0, "vfx_stars", true);
        this._stars.position.set(this._tom.x, this._tom.y - 400);
        this._stars.autoUpdate = false;
        this.addChild(this._stars);

        this._jerry = new PIXI.spine.Spine(P3.assets.spineData("jerry"));
        this._jerry.skeleton.setSlotsToSetupPose();
        this._jerry.state.setAnimation(0, "cheeky_no_controller", false);
        //this._jerry.scale.set(0.4);
        this._jerry.autoUpdate = false;
        this._jerry.position.set(common.STAGE_WIDTH * 0.5 - 330, common.STAGE_HEIGHT + 80);
        this.addChild(this._jerry);

        const states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_tertiary_small_out");
        states.over = P3.assets.texture("btn_tertiary_small_over");
        states.down = P3.assets.texture("btn_tertiary_small_down");
        states.icon = P3.assets.texture("icon_sound");
        states.iconAlt = P3.assets.texture("icon_sound_off");

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.clickSoundName = "sfx_click";
        this._muteButton.overSoundName = "sfx_rollover";
        this._muteButton.signals.up.add(function () {
            common.saveData.data.mute = !P3.audio.isMuted();
            common.saveData.save();
        }, this);
        this.addChild(this._muteButton);

        this._relaunchButton = P3.Button.create(
            P3.assets.texture("btn_primary_large_blue_out"),
            P3.assets.texture("btn_primary_large_blue_over"),
            P3.assets.texture("btn_primary_large_blue_down"),
            P3.assets.texture("icon_relaunch")
        );
        this._relaunchButton.clickSoundName = "sfx_click";
        this._relaunchButton.overSoundName = "sfx_rollover";
        this._relaunchButton.signals.click.once(this.onRelaunchButtonClick, this);
        this._relaunchButton.position.set(common.STAGE_WIDTH * 0.5 - 90, common.STAGE_HEIGHT * 0.5 + 240);
        this.addChild(this._relaunchButton);

        this._playButton = P3.Button.create(
            P3.assets.texture("btn_primary_large_green_out"),
            P3.assets.texture("btn_primary_large_green_over"),
            P3.assets.texture("btn_primary_large_green_down"),
            P3.assets.texture("icon_continue")
        );
        this._playButton.clickSoundName = "sfx_click";
        this._playButton.overSoundName = "sfx_rollover";
        this._playButton.signals.click.once(this.onPlayButtonClick, this);
        this._playButton.position.set(common.STAGE_WIDTH * 0.5 + 120, common.STAGE_HEIGHT * 0.5 + 240);
        this.addChild(this._playButton);

        this._starA = new PIXI.Sprite(P3.assets.texture("star"));
        this._starA.anchor.set(0.5);
        this._starA.visible = false;
        this._dustCloud.addChild(this._starA);

        this._starB = new PIXI.Sprite(P3.assets.texture("star"));
        this._starB.anchor.set(0.5);
        this._starB.visible = false;
        this._dustCloud.addChild(this._starB);

        this.animateJerry();
    }

    animateJerry() {
        this._jerry.state.setAnimation(0, "cheeky_no_controller", false);
        P3.utils.delayg(this._tweens, Math.random() * 5 + 5, () => this.animateJerry());
    }

    resize() {
        super.resize();

        this._muteButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 90, 90);

    }

    animateIn() {
        this.animateStarA();
        this.animateStarB();
    }

    end() {
        this.signals.next.dispatch();
    }

    update(dt = window.deltaTime) {
        super.update();

        this._tom.update(dt);
        this._jerry.update(dt);
        this._stars.update(dt);

    }

    // todo - generalise into a single function
    animateStarA() {
        this._starA.scale.set(0.6);
        this._starA.rotation = Math.PI * Math.random();
        this._starA.alpha = 0.3;
        this._starA.visible = false;

        this._starA.position.set(
            P3.math.randomInt(-this._dustCloud.width * 0.25, this._dustCloud.width * 0.25),
            P3.math.randomInt(-this._dustCloud.height * 0.25, this._dustCloud.height * 0.25)
        );

        const delay = 190 * Math.random();
        const time = P3.math.randomInt(700, 1200);

        new P3.utils.TWEEN.Tween(this._starA.scale, this._tweens)
            .delay(delay)
            .onStart(() => this._starA.visible = true)
            .to({x: 1, y: 1}, time)
            // .easing(P3.utils.TWEEN.Easing.Quadratic.In)
            .start();

        new P3.utils.TWEEN.Tween(this._starA, this._tweens)
            .delay(delay)
            .to({rotation: Math.PI * Math.random(), alpha: 0.8}, time)
            // .easing(P3.utils.TWEEN.Easing.Quadratic.In)
            .onComplete(() => this.animateStarA())
            .start();
    }

    animateStarB() {
        this._starB.scale.set(0.6);
        this._starB.rotation = Math.PI * Math.random();
        this._starB.alpha = 0.3;
        this._starB.visible = false;

        this._starB.position.set(
            P3.math.randomInt(-this._dustCloud.width * 0.25, this._dustCloud.width * 0.25),
            P3.math.randomInt(-this._dustCloud.height * 0.25, this._dustCloud.height * 0.25)
        );

        const delay = 390 * Math.random() + 120;
        const time = P3.math.randomInt(700, 1200);

        new P3.utils.TWEEN.Tween(this._starB.scale, this._tweens)
            .delay(delay)
            .onStart(() => this._starB.visible = true)
            .to({x: 1, y: 1}, time)
            // .easing(P3.utils.TWEEN.Easing.Quadratic.In)
            .start();

        new P3.utils.TWEEN.Tween(this._starB, this._tweens)
            .delay(delay)
            .to({rotation: Math.PI * Math.random(), alpha: 0.8}, time)
            // .easing(P3.utils.TWEEN.Easing.Quadratic.In)
            .onComplete(() => this.animateStarB())
            .start();
    }

    onPlayButtonClick(button) {
        this.end();
    }

    onRelaunchButtonClick(button) {
        this.signals.previous.dispatch();
    }

}


